import LoadingScreen from '../../../components/LoadingIndicators/LoadingScreen';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { RootState } from '../../../redux/store';
import { useLoginDataSetup } from './hooks/useLoginDataSetup';
import { useRedirectToHomeIfLoginDataIsNotAvailable } from './hooks/useRedirectToHomeIfLoginDataIsNotAvailable';
import { DEFAULT_AUTHENTICATED_APP_ROUTE } from '../../router/routePathNames';

const SignInCompletePage = () => {
  useRedirectToHomeIfLoginDataIsNotAvailable();
  useLoginDataSetup();
  const navigate = useNavigate();
  const isLoggedIn = useSelector((state: RootState) => state.user.isLoggedIn);

  useEffect(() => {
    if (isLoggedIn) {
      navigate(DEFAULT_AUTHENTICATED_APP_ROUTE, { replace: true });
    }
  }, [isLoggedIn, navigate]);

  return <LoadingScreen absolute showReloadAfterMs={7500} />;
};

export default SignInCompletePage;
